import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, Group } from "@/components/ui";

export function ClavesSatCentrosCostoHeader({
  total,
  modoCrear,
  onIniciarCrear,
}: {
  total: number;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Centros de costo por clave SAT"
      description={`${total} relaciones · cada clave producto/servicio puede tener varios centros de costo por sociedad; el marcado como automático es el que usa el prorrateo automático del FB60.`}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nueva relación
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
